export default __webpack_public_path__ + "static/media/menu32.cf46cbd1.svg";